import axiosInstance from './axiosInstance'

export interface SalesStage {
  id: number
  name: string
  type: 'active' | 'terminal'
  position: number
  color: string
  completionPct?: number | null
  isDefault: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateSalesStagePayload {
  name: string
  type: string
  color: string
  completionPct?: number | null
}

export interface UpdateSalesStagePayload {
  name: string;
  type: string;
  color: string;
  completionPct?: number | null;
}

export interface SalesStageReorderPayload {
  id: number
  position: number
}

export const salesStagesApi = {
  getStages: async (): Promise<SalesStage[]> => {
    const res = await axiosInstance.get<{ data: SalesStage[] }>('/sales-stages')
    return res.data.data
  },

  createStage: async (payload: CreateSalesStagePayload): Promise<SalesStage[]> => {
    const res = await axiosInstance.post<{ data: SalesStage[] }>('/sales-stages', payload)
    return res.data.data
  },

  updateStage: async (id: number, payload: UpdateSalesStagePayload): Promise<SalesStage[]> => {
    const res = await axiosInstance.put<{ data: SalesStage[] }>(`/sales-stages/${id}`, payload)
    return res.data.data
  },

  deleteStage: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/sales-stages/${id}`)
  },

  reorderStages: async (positions: SalesStageReorderPayload[]): Promise<SalesStage[]> => {
    const res = await axiosInstance.put<{ data: SalesStage[] }>('/sales-stages/reorder', positions)
    return res.data.data
  }
}
